export const /** @type {?} */ CANCEL_STATUS = {
  ACCEPTED: 1,
  NOT_ACCEPTED: 2,
  PENDING: 3,
  NOT_EXIST: 4,
};
